import { Alert, Badge, Button, Checkbox, FormField, Input, Link, LiveRegion, SegmentedControl, StatusIndicator, Table, Tabs } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useMemo, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, formatPhone, getCookie, getUrlVersion, getUserType, minutesToHHMM2, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
import { useStore } from '../../../store';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import CartesianChart from '@cloudscape-design/chart-components/cartesian-chart';
import { mdiCircle, mdiLock, mdiLockOpenVariantOutline } from '@mdi/js';
import Icon from '@mdi/react';
import Highcharts from "highcharts";
import 'highcharts/highcharts-more';
import UserAvatar from '../../../../../components/extras/UserAvatar';
import Licences from '../../../../../components/Licences';
import TableChecks from '../../../../../components/tables/tableChecks';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemCheck, ItemCountry, ItemUser, pilotTypes } from '../../../../../resources/types';

const pageSize = 10;

export const MembersEDVBioPage = () => {



    const [dataRDVM, setdataRDVM] = useState([]);
    const [dataRDVA, setdataRDVA] = useState([]);
    const [students, setStudents] = useState<any[]>([])
    const [reportType, setReportType] = useState("consolidation");

    const { menu, idUser, data, parameters } = useGlobalState();
    // Get all column names from the data dynamically

    const allPeriods = dataRDVM && dataRDVM.length > 0
        ? Object.keys(dataRDVM[0]).filter(key => key !== 'data' && key !== 'total')
        : [];

    const columnDefinitionsRDVM = [
        {
            id: 'modelCategory',
            header: 'Equipo',
            cell: (item: { data: { groupTypeMaster: any; category: any; }; }) => (<FormField label={item.data.groupTypeMaster}>{item.data.category}</FormField>),
            width: 120
            //sortingField: 'data.model'
        },
        ...allPeriods.map(period => ({
            id: period,
            header: period,
            cell: (item: { [x: string]: any; }) => {
                const value = item[period];
                if (!value) return ''; // No data
                const [hours, flights] = value.split(';');
                return (
                    <>
                        <Box textAlign='center'>
                            <SpaceBetween direction='vertical' size='xs'>
                                <span>{minutesToHHMM2(hours)}</span>
                                <Badge color="blue">{flights}</Badge>
                            </SpaceBetween>
                        </Box>
                    </>
                );
            },
            //sortingField: period
        })),
        {
            id: 'total',
            header: 'Total',
            cell: (item: { total: any; }) => {
                const value = item.total;
                if (!value) return '';
                const [hours, flights] = value.split(';');
                return (
                    <>
                        <Box textAlign='center'>
                            <SpaceBetween direction='vertical' size='xs'>
                                <span>{minutesToHHMM2(hours)}</span>
                                <Badge color="blue">{flights}</Badge>
                            </SpaceBetween>
                        </Box>
                    </>
                );
            },
            //sortingField: 'total'
        }
    ];

    const allYears = dataRDVA && dataRDVA.length > 0
        ? Object.keys(dataRDVA[0]).filter(key => key !== 'data' && key !== 'total')
        : [];

    const columnDefinitionsRDVA = [
        {
            id: 'modelCategory',
            header: 'Equipo',
            cell: (item: { data: { groupTypeMaster: string; category: string } }) => (
                <FormField label={item.data.groupTypeMaster}>{item.data.category}</FormField>
            ),
            width: 120
        },
        ...allYears.map(year => ({
            id: year,
            header: year, // just the year as header
            cell: (item: Record<string, any>) => {
                const value = item[year];
                if (!value) return (
                    <Box textAlign='center'>
                        <span>-</span>
                    </Box>
                );

                const [hours, flights] = value.split(';');
                return (
                    <Box textAlign='center'>
                        <SpaceBetween direction='vertical' size='xs'>
                            <span>{minutesToHHMM2(hours)}</span>
                            <Badge color="blue">{flights}</Badge>
                        </SpaceBetween>
                    </Box>
                );
            },
            minWidth: 100,
        })),
        {
            id: 'total',
            header: 'Total',
            cell: (item: { total: any; }) => {
                const value = item.total;
                if (!value) return '';
                const [hours, flights] = value.split(';');
                return (
                    <>
                        <Box textAlign='center'>
                            <SpaceBetween direction='vertical' size='xs'>
                                <span>{minutesToHHMM2(hours)}</span>
                                <Badge color="blue">{flights}</Badge>
                            </SpaceBetween>
                        </Box>
                    </>
                );
            },
            //sortingField: 'total'
        }
    ];
    //const storeAdmin = useStoreAdmin();

    const [keyw, setKeyw] = useState("");

    const [user, setUser] = useState<ItemUser>();

    const [helpOpen, setHelpOpen] = useState(false);
    const [sideOpen, setSideOpen] = useState(false);
    const [activeTab, setActiveTab] = useState("card");

    const [incidents, setIncidents] = useState<any[]>([]);
    const [checks, setChecks] = useState<ItemCheck[]>([]);
    const [check, setCheck] = useState<ItemCheck>();
    const [currentPageIndexChecks, setCurrentPageIndexChecks] = useState(1);
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();






    useEffect(() => {

        //console.log("activeTab changed:", activeTab);
        if (activeTab == "RDVM")
            handleGetRDVM()
        else if (activeTab == "RDVA")
            handleGetRDVA()
        else if (activeTab == "courses")
            handleGetCourses()
        else if (activeTab == "card")
            handleGetUser()
        else if (activeTab == "checks")
            handleGetChecks()
        else if (activeTab == "incidents")
            handleGetIncidents()
    }, [activeTab, parameters.pilotType]);
    useEffect(() => {
        handleGetUser()
    }, [idUser]);

    const handleDGACLicences = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/resources/sync/dgaclicences?idUser=${idUser}`, {
                method: 'POST',
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            handleGetUser()
        } catch (error: any) {
            setLoading(false)
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { }

    }
    const handleGetChecks = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/checks/requests/search',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    orderBy: "dateSubmited", order: "DESC"

                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setChecks(data.checks);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }

    }

    //

    const handleGetCourses = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/edv/students/list',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    idUser: idUser
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.students) {
                setStudents(data.students)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleGetUser = async () => {
        if (idUser > 0) {
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/user/profile/get',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const dataWeb = await response.json();
                addNotificationStatus(data, setData);
                if (dataWeb.code == 0) {
                    setUser(dataWeb.user);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally {
                setLoading(false)
            }
        };
    }
    const handleGetIncidents = async () => {

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/edv/anotations/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    idUser: idUser,
                    orderBy: "dateIncident",
                    order: "DESC",
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(data, setData);
            if (dataWeb.code == 0) {
                setIncidents(dataWeb.anotations || []);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const handleGetRDVA = async () => {
        try {
            if (parameters && parameters.pilotType && parameters.pilotType != "") {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/user/reports/flightmatrix',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        idUser: idUser,
                        type: "YEAR",
                        pilotType: parameters.pilotType
                    }),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data && data.report) {
                    setdataRDVA(data.report);
                }
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }

    }
    const handleGetRDVM = async () => {
        try {
            if (parameters && parameters.pilotType && parameters.pilotType != "") {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/user/reports/flightmatrix',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        type: "MONTH",
                        idUser: idUser,
                        pilotType: parameters.pilotType
                    }),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data && data.report) {
                    setdataRDVM(data.report);
                }
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }

    }
    const RDVMChart = React.useMemo(() => {
        // Map to store: seriesMap[seriesName][timestamp] = { y, size }
        const seriesMap: Record<string, Record<number, { y: number; size: number }>> = {};

        (dataRDVM || []).forEach((item: any) => {
            const seriesName = item.data.groupTypeMaster;

            if (!seriesMap[seriesName]) {
                seriesMap[seriesName] = {};
            }

            Object.keys(item).forEach(key => {
                // Matches either yearly ("2026") or monthly ("2026-01") keys
                if (/^\d{4}(-\d{2})?$/.test(key)) {
                    const valueStr = item[key];

                    if (valueStr && typeof valueStr === "string" && valueStr.includes(";")) {
                        const [deltaSum, flightCount] = valueStr.split(";").map(Number);

                        let timestamp: number;
                        if (key.length === 4) {
                            // Yearly key: "2026"
                            timestamp = Date.UTC(Number(key), 0, 1);
                        } else {
                            // Monthly key: "2026-01"
                            const [year, month] = key.split("-").map(Number);
                            timestamp = Date.UTC(year, month - 1, 1);
                        }

                        // Consolidate/Sum values if the timestamp already exists for this series
                        if (!seriesMap[seriesName][timestamp]) {
                            seriesMap[seriesName][timestamp] = { y: 0, size: 0 };
                        }

                        seriesMap[seriesName][timestamp].y += flightCount;
                        seriesMap[seriesName][timestamp].size += deltaSum;
                    }
                }
            });
        });

        // Transform the aggregated map into Highcharts series array format
        return Object.entries(seriesMap).map(([seriesName, timeMap]) => ({
            name: seriesName,
            type: "bubble",
            data: Object.entries(timeMap).map(([timestamp, values]) => ({
                x: Number(timestamp),
                y: values.y,
                size: values.size
            }))
        })) as any[];
    }, [dataRDVM]);

    const RDVAChart = React.useMemo(() => {
        const seriesMap: Record<string, Record<number, { y: number; size: number }>> = {};

        (dataRDVA || []).forEach((item: any) => {
            const seriesName = item.data.groupTypeMaster;

            if (!seriesMap[seriesName]) {
                seriesMap[seriesName] = {};
            }

            Object.keys(item).forEach(key => {
                if (/^\d{4}$/.test(key)) {
                    const valueStr = item[key];

                    if (valueStr && typeof valueStr === "string" && valueStr.includes(";")) {
                        const [deltaSum, flightCount] = valueStr.split(";").map(Number);
                        const year = Number(key);
                        const timestamp = Date.UTC(year, 0, 2);

                        if (!seriesMap[seriesName][timestamp]) {
                            seriesMap[seriesName][timestamp] = { y: 0, size: 0 };
                        }

                        seriesMap[seriesName][timestamp].y += flightCount;
                        seriesMap[seriesName][timestamp].size += deltaSum;
                    }
                }
            });
        });

        return Object.entries(seriesMap).map(([seriesName, timeMap]) => ({
            name: seriesName,
            type: "bubble",
            data: Object.entries(timeMap).map(([timestamp, values]) => ({
                x: Number(timestamp),
                y: values.y,
                size: values.size
            }))
        })) as any[];
    }, [dataRDVA]);


    const appendSummaryRows = (data: any[]) => {
        // Dynamically find all year keys (excluding "data" and "total")
        const years = Object.keys(data[0] || {}).filter(key => key !== 'data' && key !== 'total');

        // Helper to calculate totals for a specific filter
        const calculateRowTotals = (filterFn: (item: any) => boolean, categoryName: string, masterCode: string) => {
            const row: any = {
                data: {
                    category: categoryName, //categoryName + "1",
                    groupTypeMaster: "Totales:",
                    groupTypeMasterCode: masterCode
                }
            };

            let totalMinutes = 0;
            let totalCount = 0;

            years.forEach(year => {
                let yearMin = 0;
                let yearCount = 0;

                data.filter(filterFn).forEach(item => {
                    if (item[year]) {
                        const [m, c] = item[year].split(';').map(Number);
                        yearMin += m;
                        yearCount += c;
                    }
                });

                row[year] = yearMin > 0 || yearCount > 0 ? `${yearMin};${yearCount}` : "";
                totalMinutes += yearMin;
                totalCount += yearCount;
            });

            row.total = totalMinutes > 0 || totalCount > 0 ? `${totalMinutes};${totalCount}` : "";
            return row;
        };

        // 1. Glider Total Row
        const gliderTotal = calculateRowTotals(
            item => item.data.groupTypeMasterCode === 'GLIDER',
            'Planeador',
            'GLIDER_TOTAL'
        );

        // 2. Plane Total Row
        const planeTotal = calculateRowTotals(
            item => item.data.groupTypeMasterCode === 'PLANE',
            'Avión',
            'PLANE_TOTAL'
        );

        // 3. Grand Total Row (Glider + Plane)
        const grandTotal = calculateRowTotals(
            () => true,
            'Acumulado',
            'GRAND_TOTAL'
        );

        // Return original data plus the 3 new summary rows
        return [...data, gliderTotal, planeTotal, grandTotal];
    };
    const extendedDataRDVA = useMemo(() => {
        return appendSummaryRows(dataRDVA);
    }, [dataRDVA]);
    const extendedDataRDVM = useMemo(() => {
        return appendSummaryRows(dataRDVM);
    }, [dataRDVM]);
    const paginatedChecks: ItemCheck[] = checks.slice((currentPageIndexChecks - 1) * pageSize, currentPageIndexChecks * pageSize);
    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={sideOpen}
            onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}

            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">

                        <Header>Hoja de vida</Header>

                        {idUser > 0 && (
                            <Tabs
                                activeTabId={activeTab}
                                onChange={({ detail }) => {
                                    setActiveTab(detail.activeTabId);
                                }}
                                key={"mo"}
                                tabs={[
                                    {
                                        label: (<SpaceBetween key="space-info" size='xs' direction='horizontal'><UserAvatar width={25} idUser={user?.idUser || 0} /><span>Ficha</span></SpaceBetween>),
                                        id: "card",
                                        content: (
                                            <SpaceBetween direction='vertical' size="s">
                                                <SpaceBetween direction='horizontal' size="s">
                                                    <div style={{ maxWidth: 200 }}>
                                                        <FormField

                                                            label={<>{"RUT"}</>}

                                                        /*label={<>{"RUT"}<Link href={`#admin/users?idUser=${user?.RUT}`} external variant="primary" ></Link></>}*/
                                                        >
                                                            <Input value={user?.RUT || ""} readOnly />
                                                        </FormField>
                                                    </div>
                                                    <div style={{ maxWidth: 200 }}>
                                                        <FormField label="Apellidos">
                                                            <Input value={user?.lastName || ""} readOnly />
                                                        </FormField></div>
                                                    <div style={{ maxWidth: 200 }}>
                                                        <FormField label="Nombres">
                                                            <Input value={user?.name || ""} readOnly />
                                                        </FormField>
                                                    </div>
                                                </SpaceBetween>
                                                <SpaceBetween direction='horizontal' size="s">
                                                    <div style={{ maxWidth: 150 }}>
                                                        <FormField label="Teléfono">
                                                            <Input value={formatPhone(user?.phone1) || ""} readOnly />
                                                        </FormField>
                                                    </div>
                                                    <div style={{ maxWidth: 200 }}>
                                                        <FormField label="Email">
                                                            <Input value={user?.email || ""} readOnly />
                                                        </FormField></div>
                                                    <div style={{ maxWidth: 200 }}>
                                                        <FormField label="Email Alt." constraintText="Opcional">
                                                            <Input value={user?.email2 || ""} readOnly />
                                                        </FormField>
                                                    </div>
                                                    <div style={{ maxWidth: 200 }}>
                                                        <FormField label="Nacionalidad">
                                                            <Input value={data?.countries?.find((c: ItemCountry) => c.idCountry === user?.idCountry)?.country || ""} readOnly />
                                                        </FormField>
                                                    </div>
                                                </SpaceBetween>
                                                <SpaceBetween direction='horizontal' size="s">

                                                    <div style={{ maxWidth: 200 }}>

                                                        <FormField label="Fecha nacimiento"
                                                            constraintText={user?.age ? `${user.age} años` : ""}
                                                        >
                                                            <Input value={user?.dateBirth ? user.dateBirth : ""} readOnly />
                                                        </FormField>
                                                    </div>
                                                    <div style={{ maxWidth: 200 }}>
                                                        <FormField label="Fecha ingreso">
                                                            <Input readOnly value={user?.dateMember ? user.dateMember : ""} />
                                                        </FormField>
                                                    </div>
                                                    <div style={{ maxWidth: 150 }}>
                                                        <FormField label="Tipo de usuario">
                                                            <Input value={getUserType(user?.idUserType || 0, data).userType} readOnly />
                                                        </FormField>
                                                    </div>

                                                    <div style={{ maxWidth: 150 }}>
                                                        <FormField label="Estado">
                                                            <Checkbox checked={user?.isActiveUser === 1} readOnly>{user?.isActiveUser === 1 ? "Activo" : "Inactivo"}</Checkbox>
                                                        </FormField>
                                                    </div>

                                                </SpaceBetween>

                                                <LiveRegion>
                                                    <Alert
                                                        type="error"
                                                        header="Contacto ICE">
                                                        <SpaceBetween direction='horizontal' size="s">
                                                            <div style={{ maxWidth: 300 }}>
                                                                <FormField label="Nombre" constraintText="Persona a contactar en caso de emergencia">
                                                                    <Input value={user?.ICEContact || ""} readOnly />
                                                                </FormField>
                                                            </div>
                                                            <div style={{ maxWidth: 200 }}>
                                                                <FormField label="Teléfono">
                                                                    <Input value={formatPhone(user?.ICEPhone) || ""} readOnly />
                                                                </FormField></div>
                                                        </SpaceBetween>

                                                    </Alert>
                                                </LiveRegion>

                                            </SpaceBetween>
                                        )
                                    },
                                    {
                                        label: "Cursos",
                                        id: "courses",
                                        content: (
                                            <SpaceBetween direction='vertical' size='xs'>
                                                <Table
                                                    stickyHeader
                                                    variant='embedded'
                                                    wrapLines

                                                    columnDefinitions={[
                                                        { id: 'instructor', header: 'Alumno/Instructor', cell: item => <FormField label={item.instructor}>{item?.displayName}</FormField> },
                                                        { id: 'course', header: 'Curso', cell: item => item?.licenceType },
                                                        { id: 'start', header: 'Inicio/Termino', cell: item => <FormField label={item.dateStart}>{item?.dateLicence === "" ? <StatusIndicator type="pending">Pendiente</StatusIndicator> : <StatusIndicator type="success">{item.dateLicence}</StatusIndicator>}</FormField> },
                                                        { id: 'end', header: 'Totales', cell: item => `${item?.TotalFlights || 0}V ${minutesToHHMM2(item?.TotalTime) || 0}` },
                                                    ]}
                                                    items={students}
                                                    loadingText="Cargando alumnos..."
                                                />
                                            </SpaceBetween>
                                        )
                                    },
                                    {
                                        label: "Licencias",
                                        id: "licences",
                                        content: (
                                            <SpaceBetween direction='vertical' size='xs'>
                                                <Licences licences={user?.jsonLicences || []} />

                                                {user?.jsonLicences?.length === 0 && (
                                                    <Box textAlign='center'
                                                        margin={{ vertical: "xs" }

                                                        }>
                                                        <SpaceBetween direction='vertical' size='xs'>
                                                            No tiene licencias registradas
                                                            <Button variant="primary" onClick={() => {
                                                                handleDGACLicences()
                                                            }}>Conectar DGAC</Button>
                                                        </SpaceBetween>

                                                    </Box>
                                                )}
                                            </SpaceBetween>
                                        )
                                    },
                                    {
                                        label: "RDVM",
                                        id: "RDVM",
                                        content: (

                                            <SpaceBetween direction='vertical' size='xs'>
                                                <SpaceBetween direction='vertical' size='xs'>

                                                    <SpaceBetween direction='horizontal' size='xs'>


                                                        <FormField label="Al mando">
                                                            <SegmentedControl
                                                                selectedId={pilotTypes.find(pt => pt.value === parameters.pilotType)?.id || ""}
                                                                onChange={({ detail }) =>
                                                                    setParameters(
                                                                        { ...parameters, pilotType: detail.selectedId })
                                                                }
                                                                options={pilotTypes} />
                                                        </FormField>
                                                        {dataRDVM && dataRDVM.length > 0 && (
                                                            <FormField label="Tipo de reporte">
                                                                <SegmentedControl selectedId={reportType}
                                                                    onChange={({ detail }) => setReportType(detail.selectedId)}
                                                                    options={[
                                                                        { id: "consolidation", text: "Consolidación", disabled: !(dataRDVM && dataRDVM.length > 0) },
                                                                        { id: "distribution", text: "Distribución", disabled: !(dataRDVM && dataRDVM.length > 0) },
                                                                    ]} />
                                                            </FormField>
                                                        )}
                                                    </SpaceBetween>
                                                    {dataRDVM && dataRDVM.length > 0 && (<>
                                                        {reportType === "consolidation" && (
                                                            <Table
                                                                stickyColumns={{ first: 1, last: 1 }}
                                                                columnDefinitions={columnDefinitionsRDVM}
                                                                items={extendedDataRDVM}
                                                                stickyHeader
                                                                header={<Header variant="h2" description="Registro de vuelos mensualizados por categoría y tipo, agrupados por tiempo y cantidad de vuelos"
                                                                    actions={<></>

                                                                    }>Consolidación</Header>}
                                                                variant="embedded"
                                                                stripedRows
                                                            />
                                                        )}
                                                        {reportType === "distribution" && (

                                                            <CartesianChart
                                                                highcharts={Highcharts}


                                                                ariaLabel="Bubble chart"
                                                                chartHeight={400}
                                                                noData={{
                                                                    statusType: "finished",
                                                                    onRecoveryClick: () => { }
                                                                }}
                                                                series={RDVMChart}
                                                                sizeAxis={{
                                                                    title: "Tº de vuelo",
                                                                    valueFormatter: e => `${minutesToHHMM2(e)}`
                                                                }}
                                                                xAxis={{
                                                                    type: "datetime",
                                                                    title: "Mes",
                                                                    tickInterval: 90 * 24 * 3600 * 1000,
                                                                    valueFormatter: e => new Date(e)
                                                                        .toLocaleDateString("es-ES", {
                                                                            month: "short",
                                                                            year: "numeric",
                                                                            timeZone: "UTC"
                                                                        })
                                                                        .split(" ")
                                                                        .join("\n")
                                                                        .toUpperCase()
                                                                }}
                                                                yAxis={{
                                                                    title: "Vuelos",
                                                                    valueFormatter: function (e) {
                                                                        return e.toFixed(0);
                                                                    }
                                                                }}
                                                            />
                                                        )}</>
                                                    )}
                                                </SpaceBetween>
                                            </SpaceBetween>
                                        )
                                    },
                                    {
                                        label: "RDVA",
                                        id: "RDVA",
                                        content: (
                                            <SpaceBetween direction='vertical' size='xs'>
                                                <SpaceBetween direction='vertical' size='xs'>


                                                    <SpaceBetween direction='horizontal' size='xs'>


                                                        <FormField label="Al mando">
                                                            <SegmentedControl
                                                                selectedId={pilotTypes.find(pt => pt.value === parameters.pilotType)?.id || ""}
                                                                onChange={({ detail }) =>
                                                                    setParameters(
                                                                        { ...parameters, pilotType: detail.selectedId })
                                                                }
                                                                options={pilotTypes} />
                                                        </FormField>
                                                        {dataRDVA && dataRDVA.length > 0 && (
                                                            <FormField label="Tipo de reporte">
                                                                <SegmentedControl selectedId={reportType}
                                                                    onChange={({ detail }) => setReportType(detail.selectedId)}
                                                                    options={[
                                                                        { id: "consolidation", text: "Consolidación", disabled: !(dataRDVA && dataRDVA.length > 0) },
                                                                        { id: "distribution", text: "Distribución", disabled: !(dataRDVA && dataRDVA.length > 0) },
                                                                    ]} />
                                                            </FormField>
                                                        )}
                                                    </SpaceBetween>
                                                    {dataRDVA && dataRDVA.length > 0 && (<>
                                                        {reportType === "consolidation" && (
                                                            <Table
                                                                stickyColumns={{ first: 1, last: 1 }}
                                                                columnDefinitions={columnDefinitionsRDVA}
                                                                items={extendedDataRDVA}
                                                                stickyHeader
                                                                header={<Header variant="h2" description="Registro de vuelos anualizados por categoría y tipo, agrupados por tiempo y cantidad de vuelos"

                                                                >Consolidación</Header>}
                                                                variant="embedded"
                                                                stripedRows
                                                            />)}
                                                        {reportType === "distribution" && (

                                                            <CartesianChart
                                                                highcharts={Highcharts}


                                                                ariaLabel="Bubble chart"
                                                                chartHeight={400}
                                                                noData={{
                                                                    statusType: "finished",
                                                                    onRecoveryClick: () => { }
                                                                }}
                                                                series={RDVAChart}
                                                                sizeAxis={{
                                                                    title: "Tº de vuelo",
                                                                    valueFormatter: e => `${minutesToHHMM2(e)}`
                                                                }}
                                                                xAxis={{
                                                                    type: "datetime",
                                                                    title: "Año",
                                                                    tickInterval: 365 * 24 * 3600 * 1000,
                                                                    valueFormatter: e => new Date(e)
                                                                        .toLocaleDateString("es-ES", {
                                                                            year: "numeric"
                                                                        })
                                                                }}
                                                                yAxis={{
                                                                    title: "Vuelos",
                                                                    valueFormatter: function (e) {
                                                                        return e.toFixed(0);
                                                                    }
                                                                }}
                                                            />
                                                        )}</>
                                                    )}
                                                </SpaceBetween>
                                            </SpaceBetween>
                                        )
                                    },


                                    {
                                        label: "Chequeos",
                                        id: "checks",
                                        content: (
                                            <SpaceBetween direction='vertical' size='xs'>
                                                {checks.length > 0 && (
                                                    <TableChecks checks={checks} showPilot={false} />
                                                )}
                                            </SpaceBetween>
                                        )
                                    },
                                    {
                                        label: "Incidentes",
                                        id: "incidents",
                                        content: (
                                            <SpaceBetween direction='vertical' size='xs'>
                                                <Table
                                                    stickyHeader
                                                    variant='embedded'
                                                    wrapLines
                                                    columnDefinitions={[
                                                        {
                                                            id: 'level',
                                                            header: '',
                                                            cell: (item) => <Icon path={mdiCircle} size={1}
                                                                color={item.designation === "1" ? "green" : item.designation === "2" ? "blue" : item.designation === "3" ? "orange" : "red"} />,
                                                            width: 50,
                                                        },
                                                        {
                                                            id: 'date',
                                                            header: 'Fecha',
                                                            cell: (item) => <Link href={`#edv/anotations?id=${item.idIncident}`}>{item?.dateIncident || ""}</Link>,
                                                            width: 120,
                                                        },
                                                        {
                                                            id: 'user',
                                                            header: 'Piloto/Instructor',
                                                            cell: (item) => <FormField label={item.user}>
                                                                {item.instructor}
                                                            </FormField>,
                                                        },
                                                        {
                                                            id: 'incident',
                                                            header: 'Incidente',
                                                            cell: (item) => item.incident,
                                                        },
                                                        {
                                                            id: 'status',
                                                            header: '',
                                                            cell: (item) => item.dateClosedIncident !== "" ? <Icon path={mdiLock} size={1} /> : <Icon path={mdiLockOpenVariantOutline} color={"grey"} size={1} />,
                                                            width: 50,
                                                            minWidth: 50,
                                                        },
                                                    ]} items={incidents}
                                                    empty={
                                                        <Box>Sin incidentes registrados</Box>
                                                    }
                                                />
                                            </SpaceBetween>
                                        )
                                    }
                                ]}
                            />
                        )}
                    </SpaceBetween>
                </>
            }
        />
    );
};
